import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { FxCashNdf } from '@/store/cash/state.ts';

export const SavedCashNdfValidator = arkScope.type({
  type: '"FxNdf"',
  properties: {
    'currencyPair?': 'string',
    'maturityDateTenor?': 'string',
    'notional?': 'number',
    notionalCurrencyIndex: arkScope.type('CurrencyChoice').default(1),
  },
  tileId: 'string',
  clientId: 'number?',
});

export type SavedCashNdf = typeof SavedCashNdfValidator.infer;

export const SavedCashNdf = {
  fromFxCashNdf: (x: FxCashNdf, tileId: string): SavedCashNdf => ({
    type: 'FxNdf',
    properties: {
      currencyPair: x.properties.currencyPair,
      maturityDateTenor: x.properties.maturityDateTenor,
      notional: x.properties.notional,
      notionalCurrencyIndex: x.properties.notionalCurrencyIndex ?? 1,
    },
    tileId,
    clientId: x.clientId,
  }),
} as const;
